<template>
  <div id="perso-list">
    <ListLegend
      :legends="tableLegends"
      :isLoading="isPersonalisationsLoading"
      flexClass="justify-space-between"
      :legendsFlexStructure="legendsFlexStructure"
    />
    <div class="personalisation-list-content-wrapper">
      <v-row
        v-for="(personalisation, index) in getPersonalisations"
        :key="`${personalisation.name}-${index + 1}`"
        class="personalisation-list-content-wrapper"
        no-gutters
        @click.stop
      >
        <PersonalisationInformations
          :personalisation="personalisation"
          @click.stop
        />
      </v-row>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Personalisation } from 'ctp-personalisation-search';
import { store } from '@/store/modules/personalisation/types';
import ListLegend from '@/components/common/ListLegend/ListLegend.vue';
import PersonalisationInformations from './components/PersonalisationInformations/PersonalisationInformations.vue';
import './styles/personalisation-list-table.scss';

@Component({
  components: {
    PersonalisationInformations,
    ListLegend
  }
})
export default class PersonalisationListTable extends Vue {
  @Prop()
  private personalisationState!: any;

  @store.Getter
  private getPersonalisations!: Personalisation[];

  private legends = [
    'device.personalisation.legends.status',
    'device.personalisation.legends.update_date',
    'device.personalisation.legends.device_type',
    'device.personalisation.legends.device_id',
    'device.personalisation.legends.request_date',
    'device.personalisation.legends.operation_type',
    'device.personalisation.legends.variant',
    'device.personalisation.legends.trigger'
  ];

  private tableLegends = this.legends.concat('').map(legend => ({
    label: legend
  }));

  private legendsFlexStructure = [
    '1 1 0',
    '1 1 0',
    '1 1 0',
    '1 1 0',
    '1 1 0',
    '1 1 0',
    '1 1 0',
    '1 1 100px',
    '0 0'
  ];

  private get isPersonalisationsLoading(): boolean {
    return this.personalisationState.loading.personalisationList;
  }
}
</script>
